import { useQuery } from "@tanstack/react-query";
import { getRollsInUse, getStands } from "../repositories/RollsInUseRepository";

export const useRollsInUse = (standId: number | null) =>
	useQuery({
		queryKey: ["rollsInUse", standId],
		queryFn: ({ signal }) => getRollsInUse({ standId, signal }),
		refetchOnWindowFocus: false,
		refetchOnReconnect: false,
	});

export const useStands = () =>
	useQuery({
		queryKey: ["rollsInUse", "stands"],
		queryFn: ({ signal }) => getStands({ signal }),
		staleTime: 5 * 60 * 1000,
	});
